"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculation_1 = require("@wurzel/uzb-calculation/dist/calculation");
const util_1 = require("./util");
function getVariablesWorkSlip(move, configuration) {
    var _a, _b, _c, _d, _e;
    const calculation = calculation_1.calculate(move, configuration);
    const packingMaterials = configuration.packingMaterials;
    const packmaterialName = Object.fromEntries(packingMaterials.map((p, i) => [`packmaterial${i + 1}`, p.name]));
    const effectivePackingMaterial = calculation.packingMaterial
        .slice()
        .sort((a, b) => packingMaterials.findIndex((p) => p.id === a.packingMaterial.id) -
        packingMaterials.findIndex((p) => p.id === b.packingMaterial.id));
    const mengeVorab = Object.fromEntries(packingMaterials
        .map((p) => effectivePackingMaterial.find((ep) => ep.packingMaterial.id === p.id))
        .map((p, i) => [
        `vorabMenge${i + 1}`,
        p != null && p.inAdvance > 0
            ? `${p.inAdvance} ${util_1.getUnit(p.packingMaterial.unit)}`
            : "",
    ]));
    const mengeBeginn = Object.fromEntries(packingMaterials
        .map((p) => effectivePackingMaterial.find((ep) => ep.packingMaterial.id === p.id))
        .map((p, i) => [
        `beginnMenge${i + 1}`,
        p != null && p.amount - p.inAdvance > 0
            ? `${p.amount - p.inAdvance} ${util_1.getUnit(p.packingMaterial.unit)}`
            : "",
    ]));
    return {
        rechnung: util_1.getAddressVariables(util_1.getInvoiceAddress(move)),
        beladestelle: {
            ...util_1.getAddressVariables((_a = move.loadingAddresses[0]) !== null && _a !== void 0 ? _a : move.customer),
            etage: (_b = move.loadingAddresses[0]) === null || _b === void 0 ? void 0 : _b.floor,
        },
        entladestelle: {
            ...util_1.getAddressVariables(move.unloadingAddresses[0]),
            etage: (_c = move.unloadingAddresses[0]) === null || _c === void 0 ? void 0 : _c.floor,
        },
        ...packmaterialName,
        ...mengeVorab,
        ...mengeBeginn,
        datumBeladung: util_1.formatDate((_d = move.loadingDates[0]) === null || _d === void 0 ? void 0 : _d.date),
        datumEntladung: util_1.formatDate((_e = move.unloadingDates[0]) === null || _e === void 0 ? void 0 : _e.date),
    };
}
exports.default = getVariablesWorkSlip;
//# sourceMappingURL=workSlip.js.map